import { toAbsoluteUrl } from '_metronic/helpers'

export function findFileIconAbsoluteUrl(file: File) {
  switch (file.type) {
    case 'application/pdf':
      return toAbsoluteUrl('/media/icons/duotune/text/txt002.svg')
    case 'mp4':
      return toAbsoluteUrl('/media/icons/duotune/general/gen006.svg')
    case 'image/png':
      return toAbsoluteUrl('/media/icons/duotune/general/gen006.svg')
    case 'image/jpg':
      return toAbsoluteUrl('/media/icons/duotune/general/gen006.svg')
    case 'image/jpeg':
      return toAbsoluteUrl('/media/icons/duotune/general/gen006.svg')
    case 'image/gif':
      return toAbsoluteUrl('/media/icons/duotune/general/gen006.svg')
    case 'text/plain':
      return toAbsoluteUrl('/media/icons/duotune/text/txt002.svg')
    case 'text/csv':
      return toAbsoluteUrl('/media/icons/duotune/text/txt002.svg')
    case 'application/vnd.ms-excel':
      return toAbsoluteUrl('/media/icons/duotune/text/txt002.svg')
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return toAbsoluteUrl('/media/icons/duotune/text/txt002.svg')
    default:
      return ''
  }
}
